import { render } from "./Dashboard-route.vue?vue&type=template&id=6860073c&scoped=true"
import script from "./Dashboard-route.vue?vue&type=script&lang=js"
export * from "./Dashboard-route.vue?vue&type=script&lang=js"

import "./Dashboard-route.vue?vue&type=style&index=0&id=6860073c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6860073c"]])

export default __exports__